import { motion } from "framer-motion";
import { BedDouble, Bath, Sofa, CookingPot, ShowerHead, Sun } from "lucide-react";
import { useLanguage } from "@/i18n";

const ICONS = [BedDouble, BedDouble, Sofa, CookingPot, ShowerHead, Sun];

const Overview = () => {
  const { t } = useLanguage();
  return (
    <section id="appartamento" data-testid="overview-section" className="py-20 lg:py-32 px-6 sm:px-12 lg:px-20 bg-[#EFEAE1]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mb-16"
        >
          <p className="text-xs uppercase tracking-[0.25em] font-mono-alt font-semibold text-[#C86D51] mb-4">{t.overview.eyebrow}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0D253A]">{t.overview.title}</h2>
          <p className="mt-5 text-base sm:text-lg text-[#333D47]">{t.overview.text}</p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {t.overview.rooms.map((room, i) => {
            const Icon = ICONS[i] || Sun;
            return (
              <motion.article
                key={room.name}
                data-testid={`room-card-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.12 }}
                className="group bg-white rounded-2xl overflow-hidden border border-[#0D253A]/8 shadow-[0_10px_40px_-18px_rgba(13,37,58,0.25)] hover:-translate-y-1.5 transition-transform duration-500"
              >
                <div className="overflow-hidden h-52">
                  <img src={room.img} alt={room.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="p-2 rounded-full bg-[#F8F5F0] text-[#C86D51]">
                      <Icon className="w-4 h-4" />
                    </span>
                    <h3 className="font-display text-xl text-[#0D253A]">{room.name}</h3>
                  </div>
                  <p className="text-sm text-[#5C6773] leading-relaxed">{room.desc}</p>
                </div>
              </motion.article>
            );
          })}
        </div>

        <motion.div
          data-testid="capacity-strip"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#0D253A]/10 rounded-2xl overflow-hidden border border-[#0D253A]/10"
        >
          {t.overview.capacity.map((c, i) => (
            <div key={i} className="bg-[#0D253A] px-6 py-8 text-center">
              <p className="font-display text-3xl sm:text-4xl text-[#F8F5F0]">{c.v}</p>
              <p className="text-xs uppercase tracking-[0.18em] text-[#F8F5F0]/60 mt-2">{c.l}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Overview;
